import { useState } from "react";
import { api } from "@/api/client";
import { useAuth } from "@/auth/AuthContext";

export function Settings() {
  const { me } = useAuth();
  const [curr, setCurr] = useState("");
  const [next, setNext] = useState("");
  const [msg, setMsg] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setMsg(null);
    setLoading(true);
    try {
      await api("/api/admin/auth/change-password", {
        method: "POST",
        json: { current_password: curr, new_password: next },
      });
      setMsg("Password changed.");
      setCurr("");
      setNext("");
    } catch (e: any) {
      setErr(e?.message ?? "change failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="space-y-6 max-w-xl">
      <header>
        <h1 className="text-3xl display">Settings</h1>
        <p className="text-sm text-slate-400">Manage your admin account.</p>
      </header>
      <div className="card space-y-2">
        <h2 className="font-semibold mb-2">Account</h2>
        <Row label="Username" value={me?.username ?? "—"} />
        <Row label="Email" value={me?.email ?? "—"} />
        <Row label="Role" value={me?.role ?? "—"} />
        <Row label="TOTP enrolled" value={me?.totp_enrolled ? "yes" : "no"} />
      </div>
      <form className="card space-y-4" onSubmit={submit}>
        <h2 className="font-semibold">Change password</h2>
        <label className="block">
          <div className="text-xs text-slate-400 mb-1">Current password</div>
          <input
            type="password"
            autoComplete="current-password"
            className="input"
            value={curr}
            onChange={(e) => setCurr(e.target.value)}
            required
          />
        </label>
        <label className="block">
          <div className="text-xs text-slate-400 mb-1">New password (min 8 chars)</div>
          <input
            type="password"
            autoComplete="new-password"
            className="input"
            minLength={8}
            value={next}
            onChange={(e) => setNext(e.target.value)}
            required
          />
        </label>
        {err && <div className="text-rose-300 text-xs">{err}</div>}
        {msg && <div className="text-emerald-300 text-xs">{msg}</div>}
        <div className="flex justify-end">
          <button className="btn-primary" disabled={loading}>
            {loading ? "Saving…" : "Change password"}
          </button>
        </div>
      </form>
    </div>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex justify-between text-sm py-1">
      <span className="text-slate-500">{label}</span>
      <span className="text-slate-200">{value}</span>
    </div>
  );
}
